var lib_core = require("lib-core");

var TangentHandleView = require("./tangentHandleView");
var PathSegmentView = require("./pathSegmentView");

var PathBezierSegmentView = function (gui, interactionModel, parentGroup, layers, config, parent) {
    var self = this;
    PathSegmentView.apply(this, arguments);

    self.tan_0 = new TangentHandleView(self.gui, this.interactionModel.tan_0(), self.parentGroup, self.layers);
    self.tan_1 = new TangentHandleView(self.gui, this.interactionModel.tan_1(), self.parentGroup, self.layers);
};

lib_core.inherit(PathBezierSegmentView, PathSegmentView);
PathBezierSegmentView.$class = "PathBezierSegmentView";
module.exports = PathBezierSegmentView;

